webpackJsonp([114276838955818,60335399758886],{

/***/ 105:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(211);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(105);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 394:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(props) {
	  return _react2.default.createElement(
	    'footer',
	    { id: 'footer' },
	    _react2.default.createElement(
	      'div',
	      { className: 'inner' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'icons' },
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'https://twitter.com/idealkraft',
	              className: 'icon alt fa-twitter'
	            },
	            _react2.default.createElement(
	              'span',
	              { className: 'label' },
	              'Twitter'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'https://www.facebook.com/idealkraft/',
	              className: 'icon alt fa-facebook'
	            },
	            _react2.default.createElement(
	              'span',
	              { className: 'label' },
	              'Facebook'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'https://www.instagram.com/idealkraft/',
	              className: 'icon alt fa-instagram'
	            },
	            _react2.default.createElement(
	              'span',
	              { className: 'label' },
	              'Instagram'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: 'copyright' },
	        _react2.default.createElement(
	          'li',
	          null,
	          '\xA9 2018 idealkraft.de'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Design: ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://html5up.net' },
	            'HTML5 UP'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/datenschutz' },
	            'Datenschutzerkl\xE4rung'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: 'impressum' },
	            'Impressum'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(props) {
	  return _react2.default.createElement(
	    'header',
	    { id: 'header', className: 'alt' },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/', className: 'logo' },
	      _react2.default.createElement(
	        'strong',
	        null,
	        'idealkraft.de'
	      ),
	      ' ',
	      _react2.default.createElement(
	        'span',
	        null,
	        'Human Performance Optimization'
	      )
	    ),
	    _react2.default.createElement(
	      'nav',
	      null,
	      _react2.default.createElement(
	        'a',
	        { className: 'menu-link', onClick: props.onToggleMenu, href: 'javascript:;' },
	        'Menu'
	      )
	    )
	  );
	};
	
	Header.propTypes = {
	  onToggleMenu: _react2.default.PropTypes.func
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Menu = function Menu(props) {
	  return _react2.default.createElement(
	    'nav',
	    { id: 'menu' },
	    _react2.default.createElement(
	      'div',
	      { className: 'inner' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'links' },
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { onClick: props.onToggleMenu, to: '/' },
	            'Home'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { onClick: props.onToggleMenu, to: '/datenschutz' },
	            'Datenschutzerkl\xE4rung'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { onClick: props.onToggleMenu, to: '/impressum' },
	            'Impressum'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'a',
	      { className: 'close', onClick: props.onToggleMenu, href: 'javascript:;' },
	      'Close'
	    )
	  );
	};
	
	Menu.propTypes = {
	  onToggleMenu: _react2.default.PropTypes.func
	};
	
	exports.default = Menu;
	module.exports = exports['default'];

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(27);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(15);
	
	__webpack_require__(394);
	
	var _Header = __webpack_require__(209);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Menu = __webpack_require__(210);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Footer = __webpack_require__(208);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template(props) {
	    _classCallCheck(this, Template);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      isMenuVisible: false,
	      loading: 'is-loading'
	    };
	    _this.handleToggleMenu = _this.handleToggleMenu.bind(_this);
	    return _this;
	  }
	
	  Template.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.timeoutId = setTimeout(function () {
	      _this2.setState({ loading: '' });
	    }, 100);
	  };
	
	  Template.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.timeoutId) {
	      clearTimeout(this.timeoutId);
	    }
	  };
	
	  Template.prototype.handleToggleMenu = function handleToggleMenu() {
	    this.setState({
	      isMenuVisible: !this.state.isMenuVisible
	    });
	  };
	
	  Template.prototype.render = function render() {
	    var children = this.props.children;
	
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: 'body ' + this.state.loading + ' ' + (this.state.isMenuVisible ? 'is-menu-visible' : '')
	      },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement('link', { rel: 'stylesheet', href: (0, _gatsbyLink.withPrefix)('skel.css') })
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'wrapper' },
	        _react2.default.createElement(_Header2.default, { onToggleMenu: this.handleToggleMenu }),
	        children(),
	        _react2.default.createElement(_Footer2.default, null)
	      ),
	      _react2.default.createElement(_Menu2.default, { onToggleMenu: this.handleToggleMenu })
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	Template.propTypes = {
	  children: _react2.default.PropTypes.func
	};
	
	exports.default = Template;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-27129b9df153ae61573c.js